/*
 * File: \packages\lib\configAPI.js
 * File Created: 2022-04-05 14:18:13
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-04-07 14:35:32
 * Modified By: Li Haifeng
 */
export default class configAPI {
    constructor(config) {
        this._config = config;
    }

    getConf() {
        return this._config;
    }

    setConf(conf) {
        this._config = conf;
    }
}